module.exports = __webpack_public_path__ + "img/brid.74a038cf.gif";